import api from './api';

export interface ProdutoServico {
  id: number;
  tipo: 'produto' | 'servico';
  codigo?: string;
  nome: string;
  descricao?: string;
  valorUnit: number;
  unidade: string;
  active: boolean;
}

export interface PropostaItem {
  id?: number;
  produtoServicoId?: number;
  produtoServico?: ProdutoServico;
  descricao: string;
  quantidade: number;
  valorUnit: number;
  subtotal: number;
}

export interface Proposta {
  id: string;
  numero: number;
  tipo: 'vendas' | 'servicos';
  status: 'rascunho' | 'enviada' | 'aprovada' | 'rejeitada';
  dataEmissao: string;
  dataValidade: string;
  subtotal: number;
  desconto: number;
  valorDesconto: number;
  valorTotal: number;
  observacoes?: string;
  condicoesPagto?: string;
  visibleInPortal: boolean;
  clientId: string;
  client: { id: string; razaoSocial: string; nomeFantasia?: string };
  itens: PropostaItem[];
  criadoPor?: { id: string; name: string };
  createdAt: string;
}

export interface PropostaInput {
  clientId: string;
  tipo: 'vendas' | 'servicos';
  dataEmissao: string;
  dataValidade: string;
  desconto?: number;
  observacoes?: string;
  condicoesPagto?: string;
  itens: Omit<PropostaItem, 'id' | 'subtotal' | 'produtoServico'>[];
}

export const propostaService = {
  async list(filters?: { clientId?: string; status?: string; page?: number; limit?: number }) {
    const params = new URLSearchParams();
    if (filters?.clientId) params.append('clientId', filters.clientId);
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get(`/propostas?${params}`);
    return response.data;
  },

  async getById(id: string): Promise<Proposta> {
    const response = await api.get(`/propostas/${id}`);
    return response.data;
  },

  async create(data: PropostaInput): Promise<Proposta> {
    const response = await api.post('/propostas', data);
    return response.data;
  },

  async update(id: string, data: PropostaInput): Promise<Proposta> {
    const response = await api.put(`/propostas/${id}`, data);
    return response.data;
  },

  async updateStatus(id: string, status: string): Promise<Proposta> {
    const response = await api.patch(`/propostas/${id}/status`, { status });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/propostas/${id}`);
  },
};

export const produtoServicoService = {
  async list(filters?: { tipo?: string; search?: string; active?: boolean }): Promise<ProdutoServico[]> {
    const params = new URLSearchParams();
    if (filters?.tipo) params.append('tipo', filters.tipo);
    if (filters?.search) params.append('search', filters.search);
    if (filters?.active !== undefined) params.append('active', filters.active.toString());
    
    const response = await api.get(`/propostas/produtos-servicos?${params}`);
    return response.data;
  },

  async getById(id: number): Promise<ProdutoServico> {
    const response = await api.get(`/propostas/produtos-servicos/${id}`);
    return response.data;
  },

  async create(data: Omit<ProdutoServico, 'id' | 'active'>): Promise<ProdutoServico> {
    const response = await api.post('/propostas/produtos-servicos', data);
    return response.data;
  },

  async update(id: number, data: Partial<ProdutoServico>): Promise<ProdutoServico> {
    const response = await api.put(`/propostas/produtos-servicos/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/propostas/produtos-servicos/${id}`);
  },
};
